import React from "react";
import { SovosTypography } from "mosaic-react";

export default function TypographyWrapper(props) {
    const { value: cell } = props || {};
    const { value: stringValue } = cell || {};

    return <SovosTypography children={stringValue} />;
}
